// react
import React from "react";
import PropTypes from "prop-types";

// dependencies
import { CheckSquare, Square } from "lucide-react";

// style
import css from "./Multiselect.styl";

const Multiselect = ({ options, value, onChange, columns = 1 }) => {
	const handleChange = (action, id) => {
		let newValue = [...value];

		if (action === "add") {
			newValue.push(id);
		} else {
			newValue = newValue.filter((item) => item !== id);
		}

		onChange(newValue);
	};

	return (
		<div className={css.Main}>
			{options.map((option) => {
				const isActive = value.includes(option.id);
				const IconComponent = isActive ? CheckSquare : Square;

				return (
					<div
						key={option.id}
						onClick={() => handleChange(isActive ? "remove" : "add", option.id)}
						className={`${css.optionWrapper} ${isActive ? css.isActive : ""}`}
					>
						<div className={css.icon}>
							<IconComponent size={16} />
						</div>
						<div className={css.label}>{option.label}</div>
					</div>
				);
			})}
		</div>
	);
};

Multiselect.propTypes = {
	options: PropTypes.array.isRequired,
	value: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	columns: PropTypes.number,
};

export default Multiselect;
